import { useTranslation } from "react-i18next"

import { ellipsis } from "@f2e/shared/utils"

import { AlertBox } from "@/components"
import { Connection } from "@/types"

export interface ConnectionDeleteDialogProps {
  connection: Connection
  show: boolean
  setShow: (show: boolean) => void
  onDelete: () => void
}

const ConnectionDeleteDialog = ({
  connection,
  show,
  setShow,
  onDelete,
}: ConnectionDeleteDialogProps) => {
  const { t } = useTranslation()

  return (
    <AlertBox
      title={t("connection.connectionDeleteDialog.title")}
      description={t("connection.connectionDeleteDialog.description", {
        name: ellipsis(connection.name, 30),
      })}
      open={show}
      onOpenChange={setShow}
      onConfirm={onDelete}
    />
  )
}

export { ConnectionDeleteDialog }
export default ConnectionDeleteDialog
